import { grey, red } from "@mui/material/colors";

const styles = {
  dialog: {
    borderRadius: "16px",
  },
  mainContainer: {
    padding: "26px !important",
    maxWidth: "440px !important",
  },
  title: {
    textAlign: "center",
    fontWeight: "bold",
    color: grey[800],
    marginBottom: 26,
  },
  textfield: {
    width: "100%",
  },
  checkSuppliers: {
    paddingTop: "20px",
  },
  checkClients: {
    paddingTop: "4px",
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "end",
    width: "100%",
    padding: 0,
    marginTop: 36,
    gap: 12,
  },
  activeButton: {
    width: "120px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: red["A400"],
    color: "white",
    "&:hover": {
      backgroundColor: red["A700"],
    },
  },
  inactiveButton: {
    width: "120px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: grey[500],
    color: grey[300],
  },
  cancelButton: {
    width: "120px",
    borderRadius: "0.5rem",
    height: "38px",
    color: red["A400"],
    backgroundColor: red["50"],
  },
  circularProgress: {
    color: "white",
  }
};

export default styles;
